/* eslint-disable tsdoc/syntax */
import { SVGProps } from "react";
export const NoTransaction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 220 105"
    width="1em"
    height="1em"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g clipPath="url(#a)">
      <g opacity={0.2}>
        <rect
          width={177.5}
          height={38.97}
          x={21.247}
          y={15.433}
          fill="#F6F7F7"
          stroke="#A2A4A6"
          strokeWidth={0.5}
          rx={10.585}
        />
        <circle cx={42.667} cy={35.305} r={8.513} fill="#C9D0D6" />
        <rect
          width={89}
          height={6.191}
          x={59.693}
          y={26.792}
          fill="#C9D0D6"
          rx={3.096}
        />
        <rect
          width={58.044}
          height={5.417}
          x={59.693}
          y={36.853}
          fill="#C9D0D6"
          rx={2.709}
        />
      </g>
      <g opacity={0.2}>
        <rect
          width={177.5}
          height={35.5}
          x={21.247}
          y={69.433}
          fill="#F6F7F7"
          stroke="#A2A4A6"
          strokeWidth={0.5}
          rx={10.585}
        />
        <circle cx={42.667} cy={89.305} r={8.513} fill="#C9D0D6" />
        <rect
          width={89}
          height={6.191}
          x={59.693}
          y={80.792}
          fill="#C9D0D6"
          rx={3.096}
        />
        <rect
          width={83}
          height={5}
          x={59.997}
          y={91.183}
          fill="#C9D0D6"
          rx={2.5}
        />
      </g>
      <rect
        width={216.5}
        height={50.5}
        x={0.247}
        y={35.433}
        fill="#F6F7F7"
        stroke="#E0E0E1"
        strokeWidth={0.5}
        rx={11.75}
      />
      <circle cx={27.997} cy={60.183} r={11} fill="#DDE1E5" />
      <rect
        width={144}
        height={8}
        x={49.997}
        y={50.183}
        fill="#DDE1E5"
        rx={4}
      />
      <rect
        width={117}
        height={7}
        x={49.997}
        y={64.183}
        fill="#DDE1E5"
        rx={3.5}
      />
      <path fill="url(#b)" d="M-.003 87.183h217v24h-217z" />
      <g stroke="#F16613" strokeLinecap="round" strokeWidth={2.016}>
        <path d="M135.325 11.777v6.441M138.654 14.998h-6.657" />
      </g>
      <g stroke="#F16613" strokeLinecap="round" strokeWidth={1.21}>
        <path d="M195.903 4.692v3.865M197.9 6.625h-3.994" />
      </g>
      <g stroke="#6EBD7F" strokeLinecap="round" strokeWidth={1.613}>
        <path d="M168.61 24.015v9.018M176.898 30.83l-2.297 1.825M159.29 28.524l3.471 4.414" />
      </g>
      <path
        stroke="#C9D0D6"
        strokeWidth={0.806}
        d="M188.58 28.928c.525 0 .929.408.929.884 0 .477-.404.885-.929.885s-.928-.408-.928-.885c0-.476.403-.884.928-.884ZM144.645 30.216c.893 0 1.594.697 1.594 1.53 0 .831-.701 1.529-1.594 1.529-.893 0-1.594-.698-1.594-1.53 0-.832.701-1.529 1.594-1.529Z"
      />
      <path
        stroke="#F0B02A"
        strokeWidth={1.21}
        d="M177.264 13.67c1.155 0 2.058.902 2.058 1.972 0 1.07-.903 1.971-2.058 1.972-1.155 0-2.058-.902-2.058-1.972 0-1.07.903-1.972 2.058-1.972Z"
      />
      <path
        stroke="#5656CA"
        strokeWidth={1.613}
        d="M158.624.99c1.418 0 2.522 1.106 2.522 2.414 0 1.309-1.104 2.414-2.522 2.414-1.418 0-2.521-1.106-2.521-2.414S157.206.99 158.624.99Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={102.311}
        x2={102.311}
        y1={87.183}
        y2={111.183}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h217v106H0z" />
      </clipPath>
    </defs>
  </svg>
);
